// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8fb292a","239":"4bd1c0ca","455":"ed940aec","488":"06b0af27"}[chunkId] + ".chunk.js";
};